import { render, staticRenderFns } from "./searchProduct.html?vue&type=template&id=0c5ff8b5&scoped=true&"
import script from "./searchProduct.vue?vue&type=script&lang=js&"
export * from "./searchProduct.vue?vue&type=script&lang=js&"
import style0 from "./searchProduct.vue?vue&type=style&index=0&id=0c5ff8b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5ff8b5",
  null
  
)

export default component.exports